import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';
import '../../styles/NoDataUpgrade.css';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const NoDataUpgradePrompt = ({ title = "Analytics" }) => {
  // Generate stable chart data that never changes
  const [generatedChartData] = React.useState(() => {
    const generateRandomPattern = () => {
      return Array.from({ length: 7 }, () => Math.floor(Math.random() * 2000) + 800);
    };

    const generateRandomOutPattern = () => {
      return Array.from({ length: 7 }, () => Math.floor(Math.random() * 1800) + 600);
    };

    // Pre-generate 3 different chart datasets
    return [
      {
        labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
        datasets: [
          {
            label: 'People In',
            data: generateRandomPattern(),
            backgroundColor: 'rgba(102, 217, 255, 0.8)',
            stack: 'stack1',
          },
          {
            label: 'People Out',
            data: generateRandomOutPattern(),
            backgroundColor: 'rgba(173, 97, 214, 0.8)',
            stack: 'stack1',
          },
        ],
      },
      {
        labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
        datasets: [
          {
            label: 'People In',
            data: generateRandomPattern(),
            backgroundColor: 'rgba(102, 217, 255, 0.8)',
            stack: 'stack1',
          },
          {
            label: 'People Out',
            data: generateRandomOutPattern(),
            backgroundColor: 'rgba(173, 97, 214, 0.8)',
            stack: 'stack1',
          },
        ],
      },
      {
        labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
        datasets: [
          {
            label: 'People In',
            data: generateRandomPattern(),
            backgroundColor: 'rgba(102, 217, 255, 0.8)',
            stack: 'stack1',
          },
          {
            label: 'People Out',
            data: generateRandomOutPattern(),
            backgroundColor: 'rgba(173, 97, 214, 0.8)',
            stack: 'stack1',
          },
        ],
      }
    ];
  });

  // Generate stable random data that never changes after initial render
  const [chartData] = React.useState(() => {
    const generateRandomTotals = () => ({
      totalIn: Math.floor(Math.random() * 50000 + 10000).toLocaleString(),
      totalOut: Math.floor(Math.random() * 40000 + 8000).toLocaleString()
    });

    return [
      {
        title: "Monthly Count 2025",
        ...generateRandomTotals(),
        chartIndex: 0
      },
      {
        title: "Weekly Count Mar",
        ...generateRandomTotals(),
        chartIndex: 1
      },
      {
        title: "Daily Count",
        ...generateRandomTotals(),
        chartIndex: 2
      }
    ];
  });

  const dummyOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { 
        display: true, 
        labels: { 
          color: 'rgba(255,255,255,0.8)',
          font: { size: 11 },
          usePointStyle: true,
          padding: 15
        } 
      },
      tooltip: { enabled: false },
    },
    scales: {
      x: {
        stacked: true,
        ticks: {
          color: 'rgba(255,255,255,0.7)',
          font: { size: 10 }
        },
        grid: { display: false },
      },
      y: {
        stacked: true,
        ticks: { 
          display: true,
          color: 'rgba(255,255,255,0.5)',
          font: { size: 9 }
        },
        grid: { 
          color: 'rgba(255,255,255,0.1)',
          drawBorder: false 
        },
      },
    },
  };

  // Determine number of charts to show based on screen width
  const [chartCount, setChartCount] = React.useState(3);

  React.useEffect(() => {
    const updateChartCount = () => {
      const width = window.innerWidth;
      if (width > 1555) {
        setChartCount(3);
      } else if (width >= 1045) {
        setChartCount(2);
      } else {
        setChartCount(1);
      }
    };

    updateChartCount();
    window.addEventListener('resize', updateChartCount);
    return () => window.removeEventListener('resize', updateChartCount);
  }, []);

  return (
    <div className="blurred-graph-wrapper">
      {/* Individual chart cards to match your dashboard style */}
      <div className="charts-grid">
        {chartData.slice(0, chartCount).map((chart, index) => (
          <div key={index} className="chart-card">
            <div className="chart-header">
              <h4>{chart.title}</h4>
              <div className="chart-actions">
                <span className="chart-icon">📊</span>
                <span className="chart-icon">⛶</span>
              </div>
            </div>
            <div className="chart-stats">
              <div className="stat">
                <span className="stat-label">Total In:</span>
                <span className="stat-value cyan">{chart.totalIn}</span>
              </div>
              <div className="stat">
                <span className="stat-label">Total Out:</span>
                <span className="stat-value purple">{chart.totalOut}</span>
              </div>
            </div>
            <div className="chart-container">
              <Bar data={generatedChartData[chart.chartIndex]} options={dummyOptions} />
            </div>
          </div>
        ))}
      </div>

      {/* Blur overlay */}
      <div className="blur-overlay"></div>
      
      {/* Upgrade banner */}
      <div className="upgrade-banner">
        <div className="no-data-header">
          <span className="no-data-icon">🔒</span>
          <h4>No {title} Detected</h4>
        </div>
        <a 
          href="https://artoflogic.ai" 
          target="_blank" 
          rel="noopener noreferrer"
          className="upgrade-button"
        >
          Learn More
        </a>
      </div>
    </div>
  );
};

export default NoDataUpgradePrompt;